import { render, staticRenderFns } from "./UserContact.vue?vue&type=template&id=17ff1aed&scoped=true"
import script from "./UserContact.vue?vue&type=script&lang=js"
export * from "./UserContact.vue?vue&type=script&lang=js"
import style0 from "./UserContact.vue?vue&type=style&index=0&id=17ff1aed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ff1aed",
  null
  
)

export default component.exports